var app = angular.module('leonardo');

var LevelService = function(BaseRestService) {

  var service = new BaseRestService('levels');

  service.TYPE_STATE = 1;
  service.TYPE_COUNTY = 2;
  service.TYPE_CITY = 3;
  service.TYPE_ZIPCODE = 4;

  return service;
};

app.factory('LevelService', ['BaseRestService', LevelService]);
